var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 145,
    viewBox: "0 0 203 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    transform: "matrix(-1 0 0 1 198.76 0)",
    fill: "#ECECF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 183.443 20.918)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 174.443 20.918)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 162.443 20.918)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    transform: "matrix(-1 0 0 1 43.1055 16.8926)",
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    transform: "matrix(-1 0 0 1 103.98 32.877)",
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    transform: "matrix(-1 0 0 1 202.4 82.6084)",
    fill: "#ECECF1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 187.084 103.526)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 178.084 103.526)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 166.084 103.526)",
    fill: "#10A37F",
    stroke: "#ECECF1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    transform: "matrix(-1 0 0 1 46.3711 99.501)",
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    transform: "matrix(-1 0 0 1 107.246 115.485)",
    fill: "#16C098",
    fillOpacity: 0.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateEmpty);
export default __webpack_public_path__ + "static/media/automateEmpty.53ad371b60b8d2ec81a4ce520c870876.svg";
export { ForwardRef as ReactComponent };